import { isNil } from '@src/utils';
import { useContext } from 'react';

import { FormContext } from './FormContext';

function useFormContext() {
  const ctx = useContext(FormContext);
  if (import.meta.env.MODE === 'development') {
    if (isNil(ctx)) {
      throw new Error(
        `
          Context "FormContext" is not defined above components tree.
          It can happens when you use Field components outside Form component.
          If you need to use Field components outside form use FieldBase components.
          `,
      );
    }
  }
  // ctx is validated non-null in development; trust it in production
  return ctx as NonNullable<typeof ctx>;
}

export default useFormContext;
